module.exports = __webpack_public_path__ + "static/media/blueprint.10573cde.jpeg";